import React from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  thumbnailUrl: string;
  isCollection: boolean;
  linkUrl: string;
  title: string;
}

const MediaGridImage = ({
  thumbnailUrl,
  isCollection,
  linkUrl,
  title,
}: Props) => (
  <a className="mediaGridContent-contentItemLink" href={linkUrl}>
    {isCollection && (
      <span className="mediaGridContent-contentItemTitle">{title}</span>
    )}
    <img
      src={thumbnailUrl}
      alt="Content Background"
      className={twMerge(
        'mediaGridContent-contentItemBackgroundImage',
        isCollection && 'isCollection'
      )}
      loading="lazy"
      width="340"
      height="200"
    />
  </a>
);

export default MediaGridImage;
